export enum StatusCodeEnum {
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeOut = 504
}